import CssBaseline from "@material-ui/core/CssBaseline";
import Box from "@material-ui/core/Box";
import "./Login.css";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import Logo from "../../assets/Portal.png";
import { Button } from "../UI/Button/Button";
import InputField from "../UI/InputField/InputField";

export default function LoginPage() {
  return (
    <LoginStyled>
      <CssBaseline />
      <Link to="/">
        <img src={Logo} className="logo" alt="App Logo" />
      </Link>
      <div>
        <Typography className="heading">
          Admin <span className="heading2">Portal</span>
        </Typography>
        <Typography className="sub-heading">
          Please Sign In To Your Account To Continue
        </Typography>
      </div>
      <LoginCard />
    </LoginStyled>
  );
}

const LoginCard = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [Error, showError] = useState(null);
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/dashboard";

  const dispatch = useDispatch();

  const onSignin = (e) => {
    e.preventDefault();
    navigate("/owner-dashboard");
  };

  return (
    <div className="login-card">
      <form onSubmit={onSignin} className="Login__form">
        <div>
          <h1>Sign In</h1>
          <InputField name="email" placeholder="Email Address" bgdark={true} />
          <InputField
            name="password"
            type="password"
            placeholder="Password"
            bgdark={true}
          />
        </div>
        <div className="btn__wrapper">
          <button type="submit" className="login__btn">
            Sign In
          </button>
        </div>
      </form>
    </div>
  );
};

const LoginStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #000;
  height: 100vh;
  width: 100%;
  .logo {
    width: auto;
    height: 50vh;
    margin-top: -25vh;
  }
  .heading {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: 0.03em;
    text-align: center;
    color: #fff;
    margin-top: 20px;
  }
  .heading2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: 0.03em;
    text-align: center;
    color: #40a9ff;
  }
  .sub-heading {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #8c8c8c;
  }
  .login-card {
    min-width: 350px;
    max-width: 350px;
    min-height: 300px;
    border-radius: 20px;
    justify-content: space-between;
    align-items: center;
    background: #262626;
    padding: 20px;
    margin: 20px 0px;
    h1 {
      font-family: Poppins;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 40px;
      letter-spacing: 0.03em;
      color: #fff;
    }
  }
  .MuiInputBase-root {
    background: #000;
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    -webkit-tap-highlight-color: #40a9ff;
  }
  .MuiInputLabel-root {
    color: #fff;
  }
  .MuiIconButton-root {
    color: #999;
  }
`;
